export const setActivaUrl = (hostname) => {
    const activa = {
        API_NAME: "mfe-activa-web-cl",
        DOMAIN: "apps.stg.azr-cc-pcf.cloud.bns",
        ROUTE: "sweb/mfe/mfe-activa-web-cl",
        PRD_DOMAIN: "cloudservtrx.scotiabank.cl",
        // UAT: clouduatservtrx.scotiabank.cl/sweb/mfe/mfe-activa-web-cl
        UAT_DOMAIN: "clouduatservtrx.scotiabank.cl",
    };
    const {API_NAME, DOMAIN, ROUTE, PRD_DOMAIN, UAT_DOMAIN} = activa;
    const ENV = {
        UAT: "-uat",
        UAT_2: "clouduatservtrx",
        IST: "-ist",
        PRD: "cloudservtrx",
    };
    if (hostname.includes(ENV.IST)) {
        return `https://${API_NAME}${ENV.IST}.${DOMAIN}/${ROUTE}`;
    } else if (hostname.includes(ENV.UAT)) {
        return `https://${API_NAME}${ENV.UAT}.${DOMAIN}/${ROUTE}`;
    } else if (hostname.includes(ENV.UAT_2)) {
        return `https://${UAT_DOMAIN}/${ROUTE}`;
    } else if (hostname.includes(ENV.PRD)) {
        return `https://${PRD_DOMAIN}/${ROUTE}`;
    } else {
        return `https://${API_NAME}${ENV.UAT}.${DOMAIN}/${ROUTE}`;
        //https://mfe-activa-web-cl-uat.apps.stg.azr-cc-pcf.cloud.bns/sweb/mfe/mfe-activa-web-cl
        //https://localhost:3001/${ROUTE}
    }
};
